import { pdf } from "@react-pdf/renderer";

type PdfDocumentElement = Parameters<typeof pdf>[0];

// Renders at the roomiest density that fits on a single page, falling back to the densest when nothing does. The page
// count comes from the document itself: build passes onPageCount to a render prop (e.g. the footer's "Page x of y"),
// which react-pdf calls during layout.
export const renderFittingPdf = async (
    build: (density: number, onPageCount: (totalPages: number) => void) => PdfDocumentElement,
    densityCount: number
): Promise<Blob> => {
    let blob: Blob | null = null;
    for (let density = 0; density < densityCount; density++) {
        let totalPages = 1;
        blob = await pdf(
            build(density, (count) => {
                totalPages = count;
            })
        ).toBlob();
        if (totalPages <= 1) break;
    }
    return blob as Blob;
};
